<div class="confirm-dialog-container">
    <div class="dialogTitle">
        <span>{{title}}</span>
    </div>

    <div mat-dialog-content class="confirm-content">{{ data.warningMessage$ | async }}</div>
    <div class="pt-24 btn-container" fxLayoutAlign="end center" mat-dialog-actions>
        <form [formGroup]="dialogForm">            
            <button (click)="onContinue()" class="mat-accent mr-8 confirmbtn" mat-raised-button>Continue</button>
            <button (click)="onLogout()" class="confirmbtn cancelbtn" mat-button>Logout</button>
        </form>
    </div>
</div>